const subject = [
  {
    name: 'Ativação do usuário',
    value: 'Ativação do usuário',
  },
  {
    name: 'Dificuldade ao acessar o site',
    value: 'Dificuldade ao acessar o site',
  },
  {
    name: 'Shows',
    value: 'Shows',
  },
  {
    name: 'Workshops',
    value: 'Workshops',
  },
  {
    name: 'Sugestões e melhorias para o site',
    value: 'Sugestões e melhorias para o site',
  },
  {
    name: 'Sugestões para o canal no YouTube',
    value: 'Sugestões para o canal no YouTube',
  },
  {
    name: 'Promoções',
    value: 'Promoções',
  },
  {
    name: 'Sugestões para video aulas',
    value: 'Sugestões para video aulas',
  },
  {
    name: 'Parcerias',
    value: 'Parcerias',
  },
]

export default subject
